import { useContext } from 'react';
import { OrgContext, type OrgState } from './OrgProvider';

/** The full state, including `loading` and `noOrg`. Branch on `status`. */
export function useOrg(): OrgState {
  const state = useContext(OrgContext);
  if (!state) throw new Error('useOrg must be used inside <OrgProvider>');
  return state;
}

/**
 * The active organization's id, or `null` while it is not known yet.
 *
 * Use this for queries. Never take an org id from a prop, a route param or a
 * query string: `org_id` comes from here and RLS is the enforcement, not the
 * filter (CLAUDE.md, invariant 3).
 */
export function useOrgId(): string | null {
  const state = useOrg();
  return state.status === 'ready' ? state.orgId : null;
}
